export default __webpack_public_path__ + "static/media/SYSTEM_LOCATION.a3e114d8.svg";